import React from 'react';
import { TextField, Grid } from '@mui/material';

/**
 * Shared Inventory form fields — Add and Edit.
 */
const InventoryForm = ({ formData, errors, handleChange, handleBlur }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={4}>
      <TextField label={<span>Product Name <span style={{ color: 'red' }}>*</span></span>} name="product_name" value={formData.product_name} onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.product_name} helperText={errors.product_name || ' '} />
    </Grid>
    <Grid item xs={12} sm={4}>
      <TextField label={<span>Quantity <span style={{ color: 'red' }}>*</span></span>} name="quantity" type="number" inputProps={{ max: 999, min: 1 }} value={formData.quantity} onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.quantity} helperText={errors.quantity || ' '} />
    </Grid>
    <Grid item xs={12} sm={4}>
      <TextField label={<span>Price <span style={{ color: 'red' }}>*</span></span>} name="price" type="number" inputProps={{ max: 999999, min: 0.01 }} value={formData.price} onChange={handleChange} onBlur={handleBlur} fullWidth error={!!errors.price} helperText={errors.price || ' '} />
    </Grid>
  </Grid>
);

export default InventoryForm;
